export default "__VITE_ASSET__BQ97Gr5f__"